import { render } from "./ManageTopics.vue?vue&type=template&id=5a29657b"
import script from "./ManageTopics.vue?vue&type=script&lang=js"
export * from "./ManageTopics.vue?vue&type=script&lang=js"

import exportComponent from "/home/deployuser/prod/immivo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__